import { render, staticRenderFns } from "./ModalTeamMemberRemove.vue?vue&type=template&id=da7683a0&"
import script from "./ModalTeamMemberRemove.vue?vue&type=script&lang=js&"
export * from "./ModalTeamMemberRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports